import { HAS_WINDOW } from '@eb/feature-detection';
import { ALL_TAB, SEASONAL_TAB } from '../../../constants/tabConfig';

const SESSION_STORAGE_HOMEFEED_KEY = 'EBHomeFeedState';
const SESSION_STORAGE_ORGANIZER_TO_FOLLOW = 'OrganizerToFollow';

/**
 * Stores in sessionStorage the info require to restore the state of home-feed
 * @param {string} tabKey
 * @param {string} tabKeyLabel
 */
export const storeHomeFeedState = ({ tabKey, tabKeyLabel }) => {
    if (HAS_WINDOW) {
        sessionStorage.setItem(
            SESSION_STORAGE_HOMEFEED_KEY,
            JSON.stringify({
                tabKey,
                tabKeyLabel,
            }),
        );
    }
};

/**
 * Returns the state of home-feed.
 * Returns:
 * {tabKey (string)}
 */
export const retrieveHomeFeedState = ({ seasonalContent } = {}) => {
    let response = {
        tabKey: ALL_TAB,
        tabKeyLabel: ALL_TAB,
    };

    if (HAS_WINDOW) {
        let homeFeedState;

        try {
            homeFeedState = sessionStorage.getItem(
                SESSION_STORAGE_HOMEFEED_KEY,
            );
        } catch (error) {
            // in production, we silently fail and drop the history feature
            if (process.env.NODE_ENV === 'development') {
                throw error;
            }
        }

        if (homeFeedState) {
            homeFeedState = JSON.parse(homeFeedState);
            const shouldShowSeasonalTab =
                homeFeedState.tabKey === SEASONAL_TAB &&
                seasonalContent.byDate &&
                seasonalContent.byDate.key;
            const shouldReturnPreviousTab =
                homeFeedState.tabKey !== SEASONAL_TAB || shouldShowSeasonalTab;

            if (shouldReturnPreviousTab) {
                response = homeFeedState;
            }
        }
    }

    return response;
};
